import { CustomElement, resolve } from 'aurelia';
import { AccountService } from '../../services';
import template from './signup-nudge.html';
import './signup-nudge.css';

// Contextual sign-up nudge. Renders only while AccountService.signupNudgeOpen is set, showing a
// context-specific message (signupNudgeMessage) surfaced at a moment of intent — e.g. an
// anonymous visitor tapping a release reminder bell. Reuses the shared modal shell and login-btn
// styles. All state and the dismiss/sign-up behavior live in AccountService.
export class SignupNudgeElement {
  readonly account: AccountService = resolve(AccountService);
}

export const SignupNudge = CustomElement.define({
  name: 'signup-nudge',
  template
}, SignupNudgeElement);
